import { gaEvent } from 'src/utils'

/**
 * [TARGET]: No clique do botão "Entenda o prazo de recebimento" para abrir o modal
 *
 * [CONTEXTO]: Na geração de cobrança, ao selecionar uma parcela temos um botão "entenda o prazo de recebimento" para explicar ao usuário mais detalhes.
 *
 * [REGRAS]: n/a
 *
 */
export const viewInstallmentsModalEvent = () => {
  const event = {
    event: 'event',
    'event-category': `pagamentos-sellout:cartao-de-credito`,
    'event-action': 'view:modal',
    'event-label': 'entenda-o-prazo-de-recebimento',
  }

  gaEvent(event)
}
